// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1clk5","buttons":"PendingPaymentAlert_buttons__2ukT-"};